export default class Types {

  static ACTION_FORM_CONTACT = 'ACTION_FORM_CONTACT';
  static CLEAR_DATA_CONTACT  = 'CLEAR_DATA_CONTACT';
  static SET_DATA_CONTACT    = 'SET_DATA_CONTACT'; 

}
